import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react'

import { shape, bool, string } from 'prop-types'

function Preview({ embedUrl, sharerUsername = '', settings }) {
  const iframeRef = useRef(null)
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const previewUrl = useMemo(
    () => (sharerUsername
      ? `${embedUrl}?sharer=${encodeURIComponent(sharerUsername)}`
      : embedUrl),
    [embedUrl, sharerUsername]
  )

  useEffect(() => {
    if (!iframeLoaded || !iframeRef.current?.contentWindow) return

    iframeRef.current.contentWindow.postMessage({
      type: 'embedSettingsUpdate',
      settings,
    }, window.location.origin)
  }, [settings, iframeLoaded])

  const handleIframeLoad = useCallback(() => {
    setIframeLoaded(true)
  }, [])

  return (
    <div className="share-modal__preview">
      <span className="share-modal__input-label">
        Preview
      </span>
      <div className="share-modal__preview-container">
        <iframe
          ref={iframeRef}
          src={previewUrl}
          title="Embed preview"
          className="share-modal__preview-iframe"
          allow="autoplay"
          onLoad={handleIframeLoad}
        />
      </div>
    </div>
  )
}

Preview.propTypes = {
  embedUrl: string.isRequired,
  sharerUsername: string,
  settings: shape({
    avatar: bool.isRequired,
    modelTitle: bool.isRequired,
    name: bool.isRequired,
    views: bool.isRequired,
    rating: bool.isRequired,
    likes: bool.isRequired,
    logo: bool.isRequired,
    button: bool.isRequired,
  }).isRequired,
}

export default Preview
